import ArrowDown from 'assets/icons/ios/ios-arrow-down.svg'

ArrowDown.displayName = 'ArrowDown'
export default ArrowDown
